import IconAviso from "@mobi/ds/static/icons/outlined/aviso.svg"
import IconEmailRespostaRapida from "@mobi/ds/static/icons/outlined/email-resposta-rapida.svg"
import IconInformação from "@mobi/ds/static/icons/outlined/informação.svg"

export const iconAlerts = {
	offer: <IconInformação width={24} height={24} aria-hidden />,
	error: <IconAviso width={24} height={26} aria-hidden />,
	success: <IconEmailRespostaRapida width={24} height={26} aria-hidden />
}
